import { useEffect, useState } from "react";
import { Box, Radio, RadioGroup, Stack } from "@chakra-ui/react";
import { waveflowchatOption } from "../../redux/reducer/waveFlow";
import { useDispatch } from "react-redux";

const SelectionComponent = () => {
  const [selected, setSelected] = useState("Conversationalai");
  const dispatch=useDispatch()

  useEffect(() => {
    dispatch(waveflowchatOption(selected));
  }, [selected]);

  return (
    <Box borderRadius="md" maxW="md">
      <RadioGroup onChange={setSelected} value={selected} colorScheme="blue">
        <Stack direction="row"  justify="center">
          <Radio value="Conversationalai" fontSize="sm" size={"sm"}>
            Conversational AI Chat
          </Radio>
          {/* <Radio value="BusinessAutomation" fontSize="sm" size={"sm"}>
            Business Automation
          </Radio> */}
          <Radio value="answerAgreed" fontSize="sm" size={"sm"}>
          Citation
          </Radio>
        </Stack>
      </RadioGroup>
    </Box>
  );
};

export default SelectionComponent;
